<!-- #737: つくるセクション（/ 用、旧 MakeSection.vue の後継）。
     「自由に作って公開できる」を前面に、コンテンツ順を「羽根筆のゆりかご（自由創作・公開）→ 紙の魔導書で学ぶ（手厚いサポート）」に並べ替えた版。 -->
<template>
  <div class="centered-area">
    <LandingFadeBigTitle color="#F2A93B">
      <template #main>
        つくる
      </template>
      <template #sub>
        自由につくって、世界に公開できる。<br>
        あなたの作品で、遊んでもらおう。
      </template>
    </LandingFadeBigTitle>

    <!-- 1. 羽根筆のゆりかご：自由に作って公開 -->
    <v-row justify="center">
      <v-col
        cols="12"
        class="d-md-none"
      >
        <h3>自由につくって、世界に公開しよう<br>《羽根筆のゆりかご＆魔法研究会》</h3>
      </v-col>
      <v-col
        cols="12"
        md="5"
      >
        <v-img
          class="ma-auto elevation-24"
          src="@/assets/images/landing/AboutCodeAndMagic_Cradle.webp"
          alt="羽根筆のゆりかごの画面"
          width="640"
          cover
        />
      </v-col>
      <v-col
        cols="12"
        class="d-md-none"
      >
        <p class="my-4">
          <strong>羽根筆のゆりかご</strong>で、思いついたゲームをそのまま形に。画像・音楽・効果音のアセットも使えて、手軽に始められます。
        </p>
        <p>
          完成した作品は<strong>魔法研究会</strong>で公開して、世界中の人に遊んでもらえます。人の作品を<strong>リミックス</strong>して、自分流にアレンジするのも自由です。
        </p>
      </v-col>
      <v-col
        cols="12"
        md="7"
        class="d-none d-md-block"
      >
        <h3>自由につくって、世界に公開しよう<br>《羽根筆のゆりかご＆魔法研究会》</h3>
        <p class="my-4">
          <strong>羽根筆のゆりかご</strong>で、思いついたゲームをそのまま形に。画像・音楽・効果音のアセットも使えて、手軽に始められます。
        </p>
        <p>
          完成した作品は<strong>魔法研究会</strong>で公開して、世界中の人に遊んでもらえます。人の作品を<strong>リミックス</strong>して、自分流にアレンジするのも自由です。
        </p>
      </v-col>
    </v-row>

    <!-- 創作・公開の当事者（多作クリエイター）の声を、ゆりかごブロックのそばに -->
    <LandingVoiceCard id="ta08" />

    <!-- 2. 紙の魔導書で学ぶ：手厚いサポート -->
    <v-row
      justify="center"
      class="mt-8"
    >
      <v-col
        cols="12"
        class="d-md-none"
      >
        <h3>紙だから、打ち込む楽しさがある。<br>《エンコーディアの魔導書探索》</h3>
      </v-col>
      <v-col
        cols="12"
        md="7"
        class="d-none d-md-block"
      >
        <h3>紙だから、打ち込む楽しさがある。<br>《エンコーディアの魔導書探索》</h3>
        <p class="my-4">
          雑誌のプログラムリストを一行ずつキーボードに叩き込んで、動いた瞬間の——快感。<strong>紙の手ざわり</strong>があったからこその満足感。画面のコピー＆ペーストでは決して得られない、あの体験ごと現代に持ってきました。
        </p>
        <p>
          プログラミングが魔法になる世界<strong>エンコーディア</strong>を冒険して紙の魔導書を手に入れ、見ながら写すと、ゲームが完成する。エンコーディアで新しい魔法を手に入れていく過程で、自然と<strong>プログラミングの勘所</strong>が身につきます。
        </p>
        <p>
          わからないときは、手引書、そして女神やセンパイ（AI）がそばで支えます。初めてのあなたも、久しぶりのあなたも、ぜひ挑戦してください。
        </p>
      </v-col>
      <v-col
        cols="12"
        md="5"
      >
        <v-img
          class="ma-auto elevation-24"
          src="@/assets/images/starter/PRT1G-R2_prt_BeginnersHouse_kit.webp"
          alt="プログラミングキットの写真"
          width="640"
          cover
        />
      </v-col>
      <v-col
        cols="12"
        class="d-md-none"
      >
        <p class="my-4">
          雑誌のプログラムリストを一行ずつキーボードに叩き込んで、動いた瞬間の——快感。<strong>紙の手ざわり</strong>があったからこその満足感。画面のコピー＆ペーストでは決して得られない、あの体験ごと現代に持ってきました。
        </p>
        <p>
          プログラミングが魔法になる世界<strong>エンコーディア</strong>を冒険して紙の魔導書を手に入れ、見ながら写すと、ゲームが完成する。エンコーディアで新しい魔法を手に入れていく過程で、自然と<strong>プログラミングの勘所</strong>が身につきます。
        </p>
        <p>
          わからないときは、手引書、そして女神やセンパイ（AI）がそばで支えます。初めてのあなたも、久しぶりのあなたも、ぜひ挑戦してください。
        </p>
      </v-col>
    </v-row>

    <!-- 紙＝最大の差別化を、購入者第1号の実感で裏づける -->
    <LandingVoiceCard id="ta01" />
  </div>
</template>

<style scoped>
.centered-area {
  width: 100%;
  height: 100%;
  max-width: var(--landing-max-width);
  margin: auto;
  padding: var(--landing-gutter);
}

.centered-area h2 {
  font-size: var(--landing-h2-size);
  font-weight: 700;
  text-align: center;
  margin-top: 0;
  margin-bottom: 0.5em;
}

.centered-area h3 {
  font-family: 'Noto Sans JP', sans-serif;
  font-size: var(--landing-h3-size);
  font-weight: 500;
  text-align: center;
  margin-bottom: 0.5em;
}

.centered-area p {
  margin-bottom: 0.5em;
}
</style>
